<div class="wre-timeline-card" ngClass="updated-users">
  <div class="card-body">
    @if (audit.date) {
      <div class="wre-timeline-time">
        {{ audit.date | date: 'EEEE dd MMMM yyyy, hh:mm:ss a' }}
        @if (audit.isCollapsable) {
          <div
            style="float: right; cursor: pointer"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + title"
            aria-expanded="true"
            [attr.aria-controls]="'collapse' + title"
            class="collapseIcon">
            <span class="collapseDetailsTitle me-1"> Collapse</span>
            <span class="collapseTitle me-1">Details</span>
            <i class="fas fa-chevron-down"></i>
          </div>
        }
      </div>
    }
    @if (audit.title) {
      <div>
        {{ audit.title }}
      </div>
    }
    @if (audit.actionBy) {
      <div class="wre-timeline-user">Actioned By: {{ audit.actionBy }}</div>
    }
  </div>
</div>
@if (audit.isCollapsable) {
  <div>
    <div
      [attr.id]="'collapse' + title"
      class="collapse tabbed-content show border-top border-light hideTabList">
      <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li ngbNavItem="audit.history">
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col">
                <div class="wre-tab-container">
                  @if (audit.history) {
                    <wre-field-history-data-table
                      [list]="audit.history"
                      [fieldType]="fieldType"></wre-field-history-data-table>
                  }
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>
}
